
<lib-remboursement-capital-deces [fileMaxSize]="FILE_MAX_SIZE"
                                 [messageRequired]="MESSAGE_REQUIRED"
                                 [multiple]="IS_MULTIPLE"
                                 [fileAccept]="FILE_ACCEPT_TYPE"
                                 [fileLimit]="FILE_LIMIT"
                                 [multiple]="IS_MULTIPLE"
                                 [configuration]="configuration"
                                 [fileNamePattern]="fileNamePattern"
></lib-remboursement-capital-deces>
